import React from 'react';
import { withProductPrice } from '../../product/components/product-price/with-product-price';
const PAYPAL_CLIENT_ID = 'ARatECbVEZWpGfjfkzpFlKUg5zpTnll1HZBPBX6Ek3Aq0MiM_kMUwKiDESnScEvOmxWw957FfjTLhpba';
const PAYPAL_SCRIPT = `https://www.paypal.com/sdk/js?client-id=${PAYPAL_CLIENT_ID}&components=messages`;
const EMPTY_OBJECT = {};

import '../css/pdp-paypal-banner.less';

class PaypalBanner extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const script = document.createElement('script');
        script.src = PAYPAL_SCRIPT;
        script.async = true;
        document.body.appendChild(script);
    }

    render() {
        const { price=EMPTY_OBJECT, product=EMPTY_OBJECT, className='' } = this.props;
        const salePrice = price.salePrice || product.salePrice;
        return (
            <div 
                data-pp-message
                data-pp-placement="product"
                data-pp-amount={salePrice}
                data-pp-style-layout={"text"}
                data-pp-style-text-size="16"
                className={`${className} text default-pp-banner`}
            >
            </div>
        )
    }
}

export default withProductPrice(PaypalBanner); 

